<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                
            </section>
            <!-- Main content -->
            <section class="content">
                <el-dialog title="Forgot Password" customClass="customWidth" :visible.sync="dialogVisible" size="tiny" visible="false"  v-show ="showDialog" :before-close="handleClose">
                    <div class="account-box">
                        <form role="form">
                            <div class="form-group"> 
                                <label for="inputUsernameEmail" >Please enter the E-mail associated with the account:</label>
                                <input type="text" id="inputUsernameEmail" v-model="email" class="form-control"> </div>
                            
                            <button class="btn btn btn-primary pull-right" type="submit" v-on:click="Submit">Reset Password</button>
                        </form>                        
                        <hr>
                        <div class="row-block">
                            <div class="row">
                                
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>

<script>
var Auth = require("../services/Authentication/auth");
var to = require("await-to-js").default;
export default {
  data: function () {
    return {
      dialogVisible: false,
      showDialog: true,
     email: null
    };
  },
  methods: {
    handleClose: function (done) {
      this.showDialog = false;
      this.$router.push("/login");
      // this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning'
      // })
    },
    
    Submit: async function () {
      //CLEAN THIS UP
    // const fs = require('../../firestore')
    
    // Create a new client
        
        let email = this.email
        let error, result;
        [error, result] = await to(
          Auth.passwordResetEmail({ email}, )
        );

        if (error) {
          console.log("error", error.response);
          const errorMsg = error.response.data.error.message;
          this.$confirm("unable to send password reset email." + errorMsg, {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'});
        } else if (result) {
          console.log("result", result);
          this.$router.push({name:"passwordReset", params: {email}});

        }
          
          console.log("user", user)
      
     
    
}
      
    
    //should be a listener that handles this in the future
  
  },
};
</script>
<style scoped>
.instructionalText {
  font-weight: "bold";
  text-align: center;
        font-size: 1.2vw;

}
.wrapper {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 1fr;
}

.options-alignment {
  padding-top: 50px;
  align-content: center;
}

.box1 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 2;
}

.box2 {
  grid-column-start: 3;
  grid-column-end: 4;

  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 1;
}

.paragraph-font{
    font-size: 13pt;
      font-size: 1vw;

}

.data-font{
    font-weight: bold;
}

@media(max-width:450px){
  
.customWidth{
        width:90%;
        
    }
  
}
.customWidth{
        width:90%;
        
    }
@media(min-width:450px){
  
.customWidth{
        width:50%;
        
    }
  
}

</style>


// WEBPACK FOOTER //
// ForgotPassword.vue?53df80ce